var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Like"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1743 13.6211C20.4811 13.2786 20.668 12.8266 20.668 12.332C20.668 11.266 19.8004 10.3984 18.7344 10.3984H14.9815C15.3532 9.27051 15.5117 7.77391 15.5117 7.13238V6.48828C15.5117 5.06687 14.355 3.91016 12.9336 3.91016H12.2891C11.9934 3.91016 11.7356 4.11125 11.6639 4.39828L11.3128 5.80293C10.8208 7.77004 9.25891 9.94039 7.64242 10.3348C7.35926 9.61812 6.66016 9.10938 5.84375 9.10938H1.97656C1.62078 9.10938 1.33203 9.39813 1.33203 9.75391V21.3555C1.33203 21.7113 1.62078 22 1.97656 22H5.84375C6.61246 22 7.27762 21.5493 7.58914 20.8979L9.80375 21.6361C10.5278 21.8775 11.2823 22 12.0459 22H17.4453C18.5114 22 19.3789 21.1325 19.3789 20.0664C19.3789 19.815 19.3308 19.5744 19.2431 19.354C20.063 19.1301 20.668 18.3786 20.668 17.4883C20.668 16.9937 20.4811 16.5417 20.1743 16.1992C20.4811 15.8568 20.668 15.4047 20.668 14.9102C20.668 14.4156 20.4811 13.9636 20.1743 13.6211ZM6.48828 20.0664C6.48828 20.4218 6.1991 20.7109 5.84375 20.7109H2.62109V10.3984H5.84375C6.1991 10.3984 6.48828 10.6876 6.48828 11.043V20.0664ZM17.4453 14.2656H18.7344C19.0897 14.2656 19.3789 14.5548 19.3789 14.9102C19.3789 15.2655 19.0897 15.5547 18.7344 15.5547H17.4453C17.0895 15.5547 16.8008 15.8434 16.8008 16.1992C16.8008 16.555 17.0895 16.8438 17.4453 16.8438H18.7344C19.0897 16.8438 19.3789 17.1329 19.3789 17.4883C19.3789 17.8436 19.0897 18.1328 18.7344 18.1328H17.4453C17.0895 18.1328 16.8008 18.4216 16.8008 18.7773C16.8008 19.1331 17.0895 19.4219 17.4453 19.4219C17.8007 19.4219 18.0898 19.7111 18.0898 20.0664C18.0898 20.4218 17.8007 20.7109 17.4453 20.7109H12.0459C11.4211 20.7109 10.8036 20.6108 10.2111 20.4132L7.77734 19.6019V11.6265C8.7884 11.4344 9.77797 10.7942 10.6713 9.74617C11.5436 8.72266 12.2508 7.3657 12.5632 6.11574L12.7922 5.19922H12.9336C13.6443 5.19922 14.2227 5.77758 14.2227 6.48828V7.13238C14.2227 7.99777 13.952 9.65766 13.6056 10.3984H12.2891C11.9333 10.3984 11.6445 10.6872 11.6445 11.043C11.6445 11.3987 11.9333 11.6875 12.2891 11.6875H18.7344C19.0897 11.6875 19.3789 11.9767 19.3789 12.332C19.3789 12.6874 19.0897 12.9766 18.7344 12.9766H17.4453C17.0895 12.9766 16.8008 13.2653 16.8008 13.6211C16.8008 13.9769 17.0895 14.2656 17.4453 14.2656Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.55469 19.4219C4.91065 19.4219 5.19922 19.1333 5.19922 18.7773C5.19922 18.4214 4.91065 18.1328 4.55469 18.1328C4.19872 18.1328 3.91016 18.4214 3.91016 18.7773C3.91016 19.1333 4.19872 19.4219 4.55469 19.4219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5781 0C13.2222 0 12.9336 0.288578 12.9336 0.644531V1.97656C12.9336 2.33252 13.2222 2.62109 13.5781 2.62109C13.9341 2.62109 14.2227 2.33252 14.2227 1.97656V0.644531C14.2227 0.288578 13.9341 0 13.5781 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.8436 2.84222L9.93207 1.93073C9.6804 1.67902 9.27228 1.67902 9.02057 1.93073C8.76886 2.18244 8.76886 2.59051 9.02057 2.84222L9.93207 3.75372C10.1837 4.00539 10.5919 4.00543 10.8436 3.75372C11.0953 3.50201 11.0953 3.09393 10.8436 2.84222Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.1356 1.93073C17.8839 1.67902 17.4758 1.67902 17.2241 1.93073L16.3126 2.84218C16.0609 3.09389 16.0609 3.50197 16.3126 3.75368C16.5642 4.00539 16.9723 4.00543 17.2241 3.75372L18.1356 2.84222C18.3873 2.59051 18.3873 2.18244 18.1356 1.93073Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.88206287e8d6ee46e403c19a7daa31c6.svg";
export { ForwardRef as ReactComponent };